import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'pet-service-list',
  name: '宠物服务列表',
  icon: '宠',
  group: '宠物业务组件',
  description: '读取在架宠物服务并展示价格、时长、适用宠物和服务方式。',
  defaultProps: {
    title: '精选宠物服务',
    limit: 6,
    emptyText: '暂无在架宠物服务',
    items: []
}
}
